/** Extract a user-facing message from a DRF `{ data, errors, meta }` error response. */
export function extractError(err: unknown): string {
  const e = err as { response?: { data?: { errors?: Record<string, unknown> } } };
  const errs = e?.response?.data?.errors;
  if (!errs) return "Błąd. Spróbuj ponownie.";
  if (typeof errs.detail === "string") return errs.detail;
  return Object.values(errs)
    .flat()
    .map((v) => String(v))
    .join(" ");
}

export function formatDate(iso: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("pl-PL");
}
